module.exports = __webpack_public_path__ + "a8004303cabc36abadd974caa7168f5d.pdf";